import { validateFormat } from "@utils/formatValidator"

export const dateFormatReceiver = date => {
	const formats = [
		'yyyy-MM-ddTHH:mm:ss.SSSZ',
		'yyyy-MM-dd HH:mm:ss',
		'yyyy/MM/dd HH:mm:ss',
		'dd/MM/yyyy HH:mm:ss',
		'MM/dd/yyyy HH:mm:ss',
		'MM-dd-yy HH:mm:ss',
		'MM/dd/yy HH:mm:ss',
		'yyyyMMdd',
		'yyyy-MM-dd',
		'yyyy/MM/dd',
		'MM-dd-yy',
	]
	return formats.filter(format => validateFormat(format, date))[0]
}